
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ProjectDocument} from "@/interfaces/project.interfaces";
import {ajustHeight} from '@/shared/dom.utils';
import SAccContributorsBlock from "@/components/projects/SAccContributorsBlock.vue";
import SAccProjectContentDialog from "@/components/projects/dialog/SAccProjectContentDialog.vue";
import SAccProjectDetails from "@/components/projects/SAccProjectDetails.vue";
import SAccProjectUsers from "@/components/projects/SAccProjectUsers.vue";
import SAccProjectServices from "@/components/projects/SAccProjectServices.vue";

@Component({
  components: {
    SAccProjectServices, SAccProjectUsers, SAccProjectDetails, SAccProjectContentDialog, SAccContributorsBlock}
})
export default class SAccProjectSheet extends Vue {
  // Les props
  @Prop() private project!: ProjectDocument | null
  @Prop() private usedQuota!: number

  // Les propriétés
  public height: number = 0
  public prjname: string = ''
  public description: string = ''
  public isOpen: boolean = false
  public editName: boolean = false
  public editDesc: boolean = false
  public loading: boolean = false
  public tabId: number = 0

  // Les propriétés calculées
  public get theme() {
    return this.$store.state.theme
  }

  public get repositoryName() {
    return this.project ? this.project.name : ''
  }

   public get exceededQuota(): boolean {
    const max = this.$store.getters['projectQuota']
    return this.usedQuota >= max
  }


  // Les hooks
  public async mounted() {
    window.addEventListener('resize', this.ajustHeight)
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.ajustHeight)
  }

  // Les méthodes surveillées
  @Watch('project')
  public onChangeProject() {
    if (this.project) {
      this.isOpen = this.project.active
      this.prjname = this.project.name
      this.description = this.project.description
      this.editName = false
      this.editDesc = false
      this.$nextTick(this.ajustHeight)
    } else {
      this.isOpen = false
      this.prjname = ''
      this.description = ''
    }
  }

  // Les méthodes d'instance
  private ajustHeight() {
    this.height = ajustHeight('prjdetail', 52)
  }

  // Les méthodes statiques
}
